import React,{useState} from 'react';
import AboutFaceAI from './Components/AboutFaceAI/AboutFaceAI';
import Clarifai from "clarifai"
import Logo from  './Components/Logo/Logo';
import InputBar from './Components/InputBar/InputBar';
import FaceRecognition from './Components/FaceRecognition/FaceRecognition';
import './App.css';

   const ClarifaiApp = new Clarifai.App({
      apiKey: '8a0fde524541443cb25fdc73857914cf'
       });

 const App = () => {
  const [image, setImage] = useState("");
  const [input, setInput] = useState("")
  const [box, setBox] = useState({})

  const onInputChange = (event) => {
   setInput(event.target.value)}

   const calculateFaceLocation = (data) => {
   const ClarifaiFace = data.outputs[0].data.regions[0].region_info.bounding_box
         const img = document.getElementById("inputImage")
         const width = Number(img.width)
         const height = Number(img.height)
           console.log(width, height)
           return{
             leftCol: ClarifaiFace.left_col * width,
             topRow: ClarifaiFace.top_row * height,
             rightCol: width - (ClarifaiFace.right_col * width),
             bottomRow: height - (ClarifaiFace.bottom_row * height)
           }
   }
 
         const displayFaceBox = (box) => {
           console.log(box)
           setBox(box)
              }

  const onButtonSubmit = () => {
    setImage(input)
    ClarifaiApp.models.predict(Clarifai.FACE_DETECT_MODEL,input)
    .then(response =>displayFaceBox(calculateFaceLocation(response))).catch(err => console.log())
    }

  return( 
      <div>
         <AboutFaceAI/>
         <Logo/>
         <InputBar onButtonSubmit={onButtonSubmit} onInputChange={onInputChange}/>
         <FaceRecognition box={box} image={image} />
      </div>
  )
}
export default App;